module.exports = __webpack_public_path__ + "img/ic_benifit_exercise.903c9798.png";